import React from "react"
import Button from "@material-ui/core/Button"
import styled from "styled-components"
import TextField from "@material-ui/core/TextField"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import { useForm } from "react-hook-form"
import axios from "axios"
import { withStyles } from "@material-ui/styles"

export const StyledSection = styled.section`
  border-bottom: 1px solid #e1e1e1;
  background-color: var(--secondary);
  text-align: center;
  h2 {
    font-size: 28px;
    font-weight: bold !important;
    color: var(--grey);
    padding-top: 40px;
  }
  .MuiTypography-h6 {
    padding: 0 !important;
    font-weight: 400 !important;
  }

  @media only screen and (min-width: 1024px) {
    border-bottom: none;
  }

  @media only screen and (max-width: 900px) {
  }
`

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "var(--black)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "var(--black)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "yellow",
      },
    },
  },
})(TextField)

export default function NewsLetter() {
  //newsletter post, state validation
  const { register, handleSubmit } = useForm()

  async function onSubmitForm(values) {
    const newData = { ...values, Newsletter: true }

    let config = {
      method: "POST",
      url: "https://lafon.coeur.pw/contacts",
      headers: {
        "Content-Type": "application/json",
      },
      data: newData,
    }
    try {
      const response = await axios(config)
      //console.log(response)
      if (response.status === 200) {
        // console.log("this works")
        handleClose()
      }
    } catch (err) {
      console.error(err)
    }
  }

  // newsletter dialog box

  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <StyledSection className="pb-8">
      <h2>Join our email list</h2>
      <StyledButton id="container">
        <button className="learn-more" onClick={handleClickOpen}>
          <span className="circle" aria-hidden="true">
            <span className="icon arrow"></span>
          </span>
          <span className="button-text">Sign up</span>
        </button>
      </StyledButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ padding: "0 auto" }}>
          Subscribe
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            To subscribe to our newsletter, please enter your email address &
            name here. We will send updates occasionally.
          </DialogContentText>
          <form onSubmit={handleSubmit(onSubmitForm)} id="form">
            <CssTextField
              margin="dense"
              id="name"
              name="Name"
              inputRef={register({
                required: {
                  value: true,
                  message: "Please enter your name",
                },
              })}
              label="Name"
              type="email"
              fullWidth
            />
            <CssTextField
              name="email"
              margin="dense"
              id="email"
              inputRef={register({
                required: {
                  value: true,
                  message: "Please enter your email",
                },
                maxLength: {
                  value: 100,
                  message: "Please enter a valid email",
                },
                minLength: {
                  value: 8,
                  message: "Please enter a valid email",
                },
                pattern: {
                  value: "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$",
                  message: "Please enter a valid email",
                },
              })}
              label="Email Address"
              type="email"
              fullWidth
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="var(--red)">
            Cancel
          </Button>
          <Button onClick={handleSubmit(onSubmitForm)} color="var(--red)">
            Subscribe
          </Button>
        </DialogActions>
      </Dialog>
    </StyledSection>
  )
}

export const StyledButton = styled.div`
  * {
    box-sizing: border-box;
  }
  *::before,
  *::after {
    box-sizing: border-box;
  }

  font-size: 1.5rem;
  line-height: 2.5;

  margin-top: 2rem;

  button {
    position: relative;
    display: inline-block;
    cursor: pointer;
    outline: none;
    border: 0;
    vertical-align: middle;
    text-decoration: none;
    background: transparent;
    padding: 0;
    font-size: inherit;
    font-family: var(--ff-heading);
  }
  button.learn-more {
    width: 12rem;
    height: auto;
  }
  button.learn-more .circle {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: relative;
    display: block;
    margin: 0;
    width: 2.6rem;
    height: 2.6rem;
    background: #282936;
    border-radius: 1.625rem;
  }
  button.learn-more .circle .icon {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #fff;
  }
  button.learn-more .circle .icon.arrow {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    left: 0.4rem;
    width: 1.125rem;
    height: 0.1rem;
    background: none;
  }
  button.learn-more .circle .icon.arrow::before {
    position: absolute;
    content: "";
    top: -0.25rem;
    right: 0.0625rem;
    width: 0.625rem;
    height: 0.625rem;
    border-top: 0.1rem solid #fff;
    border-right: 0.1rem solid #fff;
    transform: rotate(45deg);
  }
  button.learn-more .button-text {
    transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    color: #282936;
    font-weight: 400;
    line-height: 1.6;
    font-size: 18px;
    text-align: center;
  }
  button:hover .circle {
    width: 100%;
  }
  button:hover .circle .icon.arrow {
    background: #fff;
    transform: translate(1rem, 0);
  }
  button:hover .button-text {
    color: #fff;
  }
  @supports (display: grid) {
    body {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 0.625rem;
      grid-template-areas: ". main main ." ". main main .";
    }
    #container {
      grid-area: main;
      align-self: center;
      justify-self: center;
    }
  }

  @media only screen and (max-width: 900px) {
  }

  .button-text {
    font-family: var(--ff-heading);
    font-weight: 400 !important;
  }
`
